import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';

import { SupplementModel } from '../../models/models';
import { ConfigurationProvider, SupplementProvider } from '../../providers/providers';

@Component({
  selector: 'page-supplement-edit',
  templateUrl: 'supplement-edit.html',
})
export class SupplementEditPage {
  item: SupplementModel;

  constructor(
    private config: ConfigurationProvider,
    private suppProvider: SupplementProvider,
    private params: NavParams,
    private viewCtrl: ViewController) {
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  dismissView(item = null) {
    // dismiss the form
    this.viewCtrl.dismiss({
      saved: true,
      name: item ? item.Name : null
    });
  }

  ionViewWillLoad() {
    this.item = this.params.get('item');
  }

  doSave() {
    if (this.formIsValid()) {
      this.config.showLoading('Saving...');

      // save item
      this.suppProvider.Save(this.item).then((res: SupplementModel) => {

        // reset and dismiss
        this.config.dismissLoading();
        this.dismissView(res); 
      });
    }
  }

  formIsValid() {
    if (!this.item.Name) {
      this.config.showAlert('Error', 'Must enter a Name.');
      return false;
    }

    // check if item exists
    if (this.suppProvider.Exists(this.item)) {
      this.config.showAlert('Error', 'Supplement with this name and brand already exists!');
      return false;
    }

    return true;
  }

}



// WEBPACK FOOTER //
// ./src/pages/food/supplement-edit.ts